import Vue from 'vue'

import L from 'leaflet'
import { LPolygon, LCircle, findRealParent, propsBinder,LMap, LTileLayer, LMarker, LPolyline, LLayerGroup, LTooltip, LPopup, LControlZoom, LControlAttribution, LControlScale, LControlLayers } 
from 'vue2-leaflet';
import  Vue2LeafletHeatmap from './heatmap/Vue2Heatmap.vue';
import 'leaflet/dist/leaflet.css'
import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';


Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-tilelayer-googlemutant', require('./heatmap/Vue2GoogleMapMuttator').default);
Vue.component('l-marker', LMarker);
Vue.component('l-circle', LCircle);
Vue.component('l-poly-line', LPolyline);
Vue.component('l-polygon', LPolygon);
Vue.component('l-layer-group', LLayerGroup);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-popup', LPopup);
Vue.component('l-control-sum', LControlZoom);
Vue.component('l-control-attribution', LControlAttribution);
Vue.component('l-control-scale', LControlScale);
Vue.component('l-control-layers', LControlLayers);
Vue.component('l-marker-cluster', Vue2LeafletMarkerCluster);
Vue.component('l-heat-point', require('./heatmap/Vue2Heatmap.vue').default);


delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});